import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppNgMaterialModule } from '../app-ng-material.module';
import { AppNgAppkitModule } from '../app-ng-appkit.module';
import { SharedComponentsModule } from '../shared/components/shared-components.module';
import { SharedDirectivesModule } from '../shared/_directives/shared-directives.module';

import { F4626Component } from './components/f4626/f4626.component';
import { OnlyDigitsDirective } from './directives/only-digits.directive';
import { OnlyPositiveDigitsDirective } from './directives/only-positive-digits.directive';
import { F4626Service } from './services/f4626.service';

@NgModule({
  declarations: [
    F4626Component,
    OnlyDigitsDirective,
    OnlyPositiveDigitsDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppNgMaterialModule,
    AppNgAppkitModule,
    SharedComponentsModule,
    SharedDirectivesModule
  ],
  exports: [
    F4626Component,
    OnlyDigitsDirective,
    OnlyPositiveDigitsDirective
  ]
})
export class F4626Module { }